import React, { useState, useEffect } from 'react';
import RemindIcon from '@rsuite/icons/legacy/Remind';
import TrashIcon from '@rsuite/icons/Trash';
import {
    Input,
    InputGroup,
    Table,
    Button,
    IconButton,
    InputPicker,
    Stack,
    Breadcrumb,
    Divider,
    Panel,
    Modal,
    Col,
    Form,
    FlexboxGrid,
    Container,
    SelectPicker,
    Uploader,
    useToaster,
    Message,
    Schema
} from 'rsuite';
import SearchIcon from '@rsuite/icons/Search';


const Category = ['Admin', 'Staff'].map(
    item => ({ label: item, value: item })
);

const Company = ['Tata', 'Reliance', 'Tesla'].map(
    item => ({ label: item, value: item })
);

const { StringType } = Schema.Types;

const model = Schema.Model({
    password: StringType().isRequired('This field is required.'),
    verifyPassword: StringType()
        .addRule((value, data) => {
            console.log(data);

            if (value !== data.password) {
                return false;
            }

            return true;
        }, 'The two passwords do not match')
        .isRequired('This field is required.')
});

const TextField = React.forwardRef((props, ref) => {
    const { name, label, accepter, ...rest } = props;
    return (
        <Form.Group controlId={`${name}-4`} ref={ref}>
            <Form.ControlLabel>{label} </Form.ControlLabel>
            <Form.Control name={name} accepter={accepter} {...rest} />
        </Form.Group>
    );
});




const AddUser = () => {

    const formRef = React.useRef();
    const [formValue, setFormValue] = React.useState({
        password: '',
        verifyPassword: '',
    });




    // POST Data from API Start
    const [dataadd, setDataadd] = useState({
        Company_Name: "",
        Full_Name: " ",
        Username: "",
        Category: "",
        Email_Id: "",
        Made_By: "Shantanu",
        MobileNo: "",
        Password: "",
        UserImage: null,
    });
    const submit = e => {
        if (dataadd.UserImage === null) {
            handleOpen1();
        } else {
            e.preventDefault();
            const formData = new FormData();
            formData.append('files.UserImage', dataadd.UserImage);
            formData.append('data', JSON.stringify(dataadd));

            fetch('http://192.168.1.83:1337/api/user-details', {
                method: 'POST',
                body: formData,

            })
                .then(response => fetchData())
                .then(data => console.log(data))
                .catch(error => console.error(error));
            toaster.push(message, { placement });
            
            handleClose();
        }
    };
    // POST Data from API End


    const [placement, setPlacement] = React.useState('topCenter');
    const toaster = useToaster();
    const message = (
        <Message showIcon type='success' closable>
            Saved Successfully
        </Message>
    );

    const handleInputChange = (inputName, value) => {
        setDataadd({ ...dataadd, [inputName]: value });
    }
    const handleImageUpload = fileList => {
        setDataadd({
            ...dataadd,
            UserImage: fileList[0].blobFile
        });
    };

    // Fetch Data from API Start
    const [data, setData] = React.useState([]);
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        const response = await fetch('http://192.168.1.83:1337/api/user-details?populate=*');
        const json = await response.json();
        setData(json.data);
    };
    //  Fetch Data from API End


    // Delete Data from API Start
    const handleDeleteRow = async (rowId) => {
        try {
            const response = await fetch(`http://192.168.1.83:1337/api/user-details/${rowId}`, {
                method: 'DELETE',
            });
            if (response.ok) {
                // Row deletion was successful, update your local data or refresh the table
                const updatedData = data.filter((row) => row.id !== rowId);
                setData(updatedData);
                console.log('Row deleted successfully.');
            } else {
                console.log('Failed to delete row.');
            }
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    };
    // Fetch Data from API End

    const ip = 'http://192.168.1.83:1337'

    // for from
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    // for alert
    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = () => setOpen1(true);
    const handleClose1 = () => setOpen1(false);

    return (
        <>
            <Container className='main'>
                <Stack className="table-toolbar " justifyContent="space-between">
                    <Stack.Item alignSelf="flex-start">
                        <Stack direction='column' alignItems='flex-start' >
                            <h3 className="title">Add User</h3>
                            <Breadcrumb>
                                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                                <Breadcrumb.Item active>Add User</Breadcrumb.Item>
                            </Breadcrumb>
                        </Stack>
                    </Stack.Item>
                    <Stack direction='column' alignItems='flex-end' spacing={20} >
                        <Button color="cyan" appearance="primary" onClick={handleOpen}>
                            Add User
                        </Button>
                        <InputGroup inside >
                            <Input placeholder="Search" />
                            <InputGroup.Addon>
                                <SearchIcon />
                            </InputGroup.Addon>
                        </InputGroup>
                    </Stack>
                </Stack>
                <Divider className='divide' />
                <Panel>
                    <Table
                        rowHeight={60}
                        data={data}
                        height={500}
                        rowKey="id"
                    >
                        <Table.Column width={60} align="center" fixed>
                            <Table.HeaderCell><b>ID</b></Table.HeaderCell>
                            <Table.Cell dataKey="id" />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Company Name</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'Company_Name']} />
                        </Table.Column>


                        <Table.Column width={100} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Image</b></Table.HeaderCell>
                            <Table.Cell >{(rowData) => (
                                <img
                                    src={`${ip}${rowData.attributes.UserImage.data.attributes.url}`}
                                    alt="User Image"
                                    style={{ width: 50, height: 50, marginTop: '-16px' }}
                                />
                            )}</Table.Cell>
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Full Name</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'Full_Name']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Username</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'Username']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Category</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'Category']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Email</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'Email_Id']} />
                        </Table.Column>

                        <Table.Column width={150} align="center" flexGrow={1}>
                            <Table.HeaderCell><b>Mobile No.</b></Table.HeaderCell>
                            <Table.Cell dataKey={['attributes', 'MobileNo']} />
                        </Table.Column>
                        <Table.Column width={150} fixed="right">
                            <Table.HeaderCell><b>Action</b></Table.HeaderCell>

                            <Table.Cell style={{ padding: '6px' }}>
                                {(rowData) => (

                                    <IconButton
                                        size="sm"
                                        icon={<TrashIcon />}
                                        active
                                        onClick={() => handleDeleteRow(rowData.id)}
                                    />
                                )}
                            </Table.Cell>
                        </Table.Column>
                    </Table>
                </Panel>
                <Modal size="lg" backdrop='static' open={open} onClose={handleClose}>
                    <Modal.Header>
                        <Modal.Title><h5>Create User</h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form fluid ref={formRef}
                            onChange={setFormValue}
                            formValue={formValue}
                            model={model}>
                            <FlexboxGrid justify="space-between">
                                <FlexboxGrid.Item as={Col} colspan={24} md={12}>

                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Comapany Name</Form.ControlLabel>
                                        <SelectPicker
                                            block
                                            id="Company_Name"
                                            name="Company_Name"
                                            value={dataadd && dataadd.Company_Name ? dataadd.Company_Name : ''} onChange={value => handleInputChange('Company_Name', value)} data={Company} />

                                    </Form.Group>
                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Username</Form.ControlLabel>
                                        <Input
                                            id="Username"
                                            name="Username"
                                            value={dataadd && dataadd.Username ? dataadd.Username : ''} onChange={value => handleInputChange('Username', value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="password-1">
                                        <Form.ControlLabel>Password</Form.ControlLabel>
                                        <TextField name="password" type="password" autoComplete="off"
                                            id="Password"
                                            value={dataadd && dataadd.Password ? dataadd.Password : ''} onChange={value => handleInputChange('Password', value)}
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="email-1">
                                        <Form.ControlLabel>Email</Form.ControlLabel>
                                        <Input
                                            id="Email_Id"
                                            name="Email_Id"
                                            value={dataadd && dataadd.Email_Id ? dataadd.Email_Id : ''} onChange={value => handleInputChange('Email_Id', value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Add User Image</Form.ControlLabel>
                                        <Stack>
                                            <Uploader style={{ display: 'flex', gap: '20px' }} active listType="picture-text" renderFileInfo={(file, fileElement) => {
                                                return (
                                                    <>
                                                        <span>File Name: {file.name}</span>
                                                        <p>File URL: {file.url}</p>
                                                    </>
                                                );
                                            }} onChange={handleImageUpload} action={''} />
                                        </Stack>
                                    </Form.Group>

                                </FlexboxGrid.Item>
                                <FlexboxGrid.Item as={Col} colspan={24} md={12} >

                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Full Name</Form.ControlLabel>
                                        <Input
                                            id="Full_Name"
                                            name="Full_Name"
                                            value={dataadd && dataadd.Full_Name ? dataadd.Full_Name : ''} onChange={value => handleInputChange('Full_Name', value)}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Category</Form.ControlLabel>
                                        <InputPicker
                                            block
                                            id="Category"
                                            name="Category"
                                            value={dataadd && dataadd.Category ? dataadd.Category : ''} onChange={value => handleInputChange('Category', value)} data={Category}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="password-1">
                                        <Form.ControlLabel>Confirm Password</Form.ControlLabel>
                                        <TextField
                                            name="verifyPassword"
                                            type="password"
                                            autoComplete="off"
                                        />
                                    </Form.Group>

                                    <Form.Group controlId="name-1">
                                        <Form.ControlLabel>Mobile Number</Form.ControlLabel>
                                        <Input
                                            id="MobileNo"
                                            name="MobileNo"
                                            value={dataadd && dataadd.MobileNo ? dataadd.MobileNo : ''} onChange={value => handleInputChange('MobileNo', value)}
                                        />
                                    </Form.Group>


                                </FlexboxGrid.Item>
                            </FlexboxGrid>
                        </Form>

                    </Modal.Body>
                    <Modal.Footer>
                        <Stack justifyContent='space-between'>
                            <Button onClick={handleClose} appearance="default" active>
                                Cancel
                            </Button>
                            <Button onClick={submit} appearance="primary" color='cyan'>
                                Create User
                            </Button>
                        </Stack>
                    </Modal.Footer>
                </Modal>

                <Modal backdrop="static" role="alertdialog" open={open1} onClose={handleClose1} size="xs">
                    <Modal.Body>
                        <RemindIcon style={{ color: '#ffb300', fontSize: 24 }} />
                        Please fill the all feilds!
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={handleClose1} appearance="subtle" active>
                            Cancel
                        </Button>
                        <Button onClick={handleClose1} appearance="primary" color='cyan'>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
                    <div className="container">
                        <p>© All Right Reserved. Product by </p>
                    </div>
                    <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
                </Stack>
            </Container>
        </>
    );
};

export default AddUser;

